export const SIGN_OUT = 'SIGN_OUT'
export const SIGN_IN = 'SIGN_IN'
export const CREATE_STREAM = 'CREATE_STREAM'
export const FETCH_STREAMS = 'FETCH_STEAMS'
export const FETCH_STREAM = 'FETCH_STREAM'
export const DELETE_STREAM = 'DELETE_STREAM'
export const EDIT_STREAM = 'EDIT_STREAM'

